import { motion } from 'framer-motion';
import { Typography } from '@altify/components';
import { useContent } from '@altify/utils';
import { CopyIcon } from 'assets/icons/CopyIcon';
import { content } from '../AiInsights.content';

interface CopyButtonProps {
  onCopy: () => void;
  copied: boolean;
}

/**
 * Copy button with animation and feedback
 */
export function CopyButton({ onCopy, copied }: CopyButtonProps) {
  const localizedContent = useContent(content);

  return (
    <div className="flex items-center gap-2">
      <motion.button
        onClick={onCopy}
        className="transition-all active:scale-95 flex items-center"
        disabled={copied}
        whileHover={{ scale: 1.02 }}
        whileTap={{ scale: 0.98 }}
        animate={copied ? { scale: [1, 1.1, 1] } : { scale: 1 }}
        transition={{ duration: 0.2 }}>
        <motion.div
          animate={copied ? { rotate: [0, 10, -10, 0] } : { rotate: 0 }}
          transition={{ duration: 0.3 }}>
          <CopyIcon />
        </motion.div>
      </motion.button>
      {copied && (
        <motion.div
          initial={{ opacity: 0, x: -10 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2 }}>
          <Typography size="small" className="text-neutral-300">
            {localizedContent.copiedToClipboard}
          </Typography>
        </motion.div>
      )}
    </div>
  );
}
